import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { updateStaffPreviousWorkInfo } from "../../../redux/slice/staff/staffSlice";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import Form from "../../form/Form";
import PhoneInput from "react-phone-number-input";

const PreviousPlaceOfWork = () => {
  const dispatch = useDispatch();

  const { prev_place_work_information } = useSelector(
    (state) => state?.staff.staff_information
  );
  const { user_permissions } = useSelector((state) => state.auth?.user);

  const [hasEditStaff, setHasEditStaff] = useState();
  const [reasonTextField, setReasonTextField] = useState(false);
  const [hasWorkExperience, setHasWorkExperience] = useState(false);

  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});
  const [prevWorkInfo, setPrevWorkInfoInfo] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("red");
      setErrorMessage("Please enter phone number ");
    } else {
      setBorderColor("");
      setErrorMessage("");

      setPhoneNumber(phone_no);
    }
    setStaffInputData(staffInputData);
  };

  const resetOnClose = () => {
    setEditing(editing ? false : true);
    setBorderColor("");
    setErrorMessage("");
    setPhoneNumber(prevWorkInfo?.reporting_officer_number);
    setStaffInputData({
      ...staffInputData,
      company_address: prevWorkInfo?.company_address,
      company_name: prevWorkInfo?.company_name,
      job_description: prevWorkInfo?.job_description,
      object_status: prevWorkInfo?.object_status,
      verify_reasons: prevWorkInfo?.verify_reasons,
      id: prevWorkInfo?.id,
    });
  };

  // Update Personal Info
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(
        updateStaffPreviousWorkInfo({
          ...staffInputData,
          reporting_officer_number: phoneNumber,
        })
      );
    }
  };

  // declare input fields variables
  const [staffInputData, setStaffInputData] = useState({
    company_address: "",
    company_name: "",
    job_description: "",
    object_status: "",
    reporting_officer_number: "",
    verify_reasons: "",
  });

  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  // reset erro state handler
  const resetError = () => {
    setError({});
  };

  // Reset error state
  useEffect(() => {
    resetError();
  }, [hasWorkExperience]);

  useEffect(() => {
    setPrevWorkInfoInfo(prev_place_work_information);
    if (prev_place_work_information) {
      setStaffInputData({
        ...staffInputData,
        company_address: prevWorkInfo?.company_address,
        company_name: prevWorkInfo?.company_name,
        job_description: prevWorkInfo?.job_description,
        object_status: prevWorkInfo?.object_status,
        verify_reasons: prevWorkInfo?.verify_reasons,
        id: prevWorkInfo?.id,
      });
      setPhoneNumber(prevWorkInfo?.reporting_officer_number);
    }
  }, [prev_place_work_information]);

  useEffect(() => {
    setHasEditStaff(
      user_permissions?.some((permission) => permission.name === "edit staff")
    );
  }, [user_permissions]);

  return (
    <div className='border p-4 rounded-3 mt-4 px-3 position-relative'>
      <h4 className='fw-bold text-primary bg-white position-absolute profile-title'>
        Previous Place Of Work
      </h4>
      {prev_place_work_information ? (
        <>
          <Form
            setError={(e) => {
              if (!phoneNumber) {
                setBorderColor("#fa5c7c");
                setErrorMessage("phone number is required.");
              }
              setError(e);
            }}
            submitHandler={handleSubmit}
            values={staffInputData}
          >
            <div className='row shadow-lg p-3 mb-2'>
              <div className='col-xs-6 col-sm-6 col-md-4'>
                <h5>Company Name</h5>
                {!editing && <p>{prev_place_work_information.company_name}</p>}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.company_name && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='company name'
                    type='text'
                    name='company_name'
                    value={input.company_name}
                    onChange={handleChange}
                    placeholder='Company Name'
                    id='company_name'
                  />
                )}
                {error.company_name && (
                  <span className='invalid-feedback'>{error.company_name}</span>
                )}
              </div>
              <div className='col-xs-6 col-sm-6 col-md-4'>
                <h5>Job Description</h5>
                {!editing && (
                  <p>{prev_place_work_information.job_description}</p>
                )}
                {editing && (
                  <input
                    className={`form-control update-input ${
                      error.job_description && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    textname='Job description'
                    type='text'
                    name='job_description'
                    value={input.job_description}
                    onChange={handleChange}
                    placeholder='Job description'
                    id='job_description'
                  />
                )}
                {error.job_description && (
                  <span className='invalid-feedback'>
                    {error.job_description}
                  </span>
                )}
              </div>
              <div className='col-xs-6 col-sm-6 col-md-4'>
                <h5>Reporting Officer Number Name</h5>
                <p>
                  {!editing &&
                    prev_place_work_information.reporting_officer_number}
                </p>
                {editing && (
                  <div className='custom-prefix position-relative'>
                    <PhoneInput
                      placeholder='Enter phone number'
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setBorderColor("red");
                          setErrorMessage("Please enter phone number");
                        } else {
                          setBorderColor("");
                          setErrorMessage("");
                        }
                      }}
                      defaultCountry={null}
                      className='form-control custom-phone-input'
                      style={{ borderColor: `${borderColor}` }}
                    />
                    {errorMessage && (
                      <span
                        className='text-danger'
                        style={{ fontSize: "12px" }}
                      >
                        {errorMessage}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className='row shadow-lg p-3 mb-2'>
              <div className='col-sm-6 col-md-8'>
                <h5>Company Address</h5>
                {!editing && (
                  <p>{prev_place_work_information.company_address}</p>
                )}
                {editing && (
                  <textarea
                    textname='company address'
                    className={`form-control update-input ${
                      error.company_address && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    name='company_address'
                    value={input.company_address}
                    onChange={handleChange}
                    placeholder='Company Address'
                    id='company_address'
                    cols='70'
                    rows='3'
                  ></textarea>
                )}
                {error.company_address && (
                  <span className='invalid-feedback'>
                    {error.company_address}
                  </span>
                )}
              </div>
              <div className='col-sm-6 col-xs-6 col-md-4'>
                <h5>Consent To Verify</h5>
                {!editing && (
                  <p>
                    {prev_place_work_information.object_status == 1
                      ? "Yes"
                      : "No"}
                  </p>
                )}
                {editing && (
                  <div className=''>
                    {/* <!-- Dark Switch--> */}
                    <input
                      validate='false'
                      textname='answer'
                      name='object_status'
                      // value={reasonTextField ? 'Yes' : 'No'}
                      value={
                        input.object_status ? input.object_status : "false"
                      }
                      onChange={handleChange}
                      className={`form-control ${
                        error.object_status && "is-invalid"
                      }`}
                      type='checkbox'
                      id='switch8'
                      data-switch='secondary'
                    />
                    <label
                      htmlFor='switch8'
                      data-on-label='No'
                      data-off-label='Yes'
                      className='mx-lg-2'
                      onClick={() => {
                        setReasonTextField(!reasonTextField);
                        setHasWorkExperience(!hasWorkExperience);
                      }}
                    ></label>
                    {error.object_status && (
                      <span className='invalid-feedback'>
                        {error.object_status}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className='row shadow-lg p-3 mb-3'>
              <div className='col-sm-6 col-md-12'>
                <h5>Reasons</h5>
                {!editing && (
                  <p>{prev_place_work_information.verify_reasons}</p>
                )}
                {editing && reasonTextField && (
                  <textarea
                    textname='reasons'
                    className={`form-control update-input ${
                      error.verify_reasons && "is-invalid"
                    }`}
                    minLength='2'
                    maxLength='255'
                    name='verify_reasons'
                    value={input.verify_reasons}
                    onChange={handleChange}
                    placeholder='Reasons'
                    id='verify_reasons'
                    cols='70'
                    rows='3'
                  ></textarea>
                )}
                {error.verify_reasons && (
                  <span className='invalid-feedback'>
                    {error.verify_reasons}
                  </span>
                )}
              </div>
            </div>
            {hasEditStaff && (
              <div className='d-flex float-end '>
                <div>
                  <a
                    className={`btn btn-${
                      editing ? "warning" : "info"
                    } btn-sm mt-3 px-4 text-white`}
                    onClick={() => resetOnClose()}
                  >
                    {editing ? "Close" : "Edit"}
                  </a>
                  {editing && (
                    <button className='btn btn-success ms-2 btn-sm mt-3 px-4'>
                      Save
                    </button>
                  )}
                </div>
              </div>
            )}
            <div className='clearfix'></div>
          </Form>
        </>
      ) : (
        <div className='alert alert-info'>No Record Found</div>
      )}
    </div>
  );
};

export default PreviousPlaceOfWork;
